"use client";
import Image from "next/image";
import { printHTML } from "../../../hooks/utils/formatter";

function extractFromInnerHTML(html) {
  if (!html) return { url: undefined, alt: "", caption: undefined };
  const url = (html.match(/<img[^>]+src=["']([^"']+)["']/i) || [])[1];
  const alt = (html.match(/<img[^>]+alt=["']([^"']*)["']/i) || [])[1] ?? "";
  const caption = (html.match(/<figcaption[^>]*>([\s\S]*?)<\/figcaption>/i) || [])[1];
  return { url, alt, caption };
}

const CoreImage = ({ data, isGallery = false, openImage }) => {
  const { width, height, additional_data } = data?.attrs || {};
  const parent_attrs = data?.parent_attrs;
  const parentisGallery = !!parent_attrs?.block_name?.endsWith?.("/gallery");

  let columns;
  if (parent_attrs && parentisGallery) {
    columns = parent_attrs?.columns || 3;
  }

  let url = additional_data?.url;
  let alt = additional_data?.alt ?? "";
  let caption = additional_data?.caption;

  if (!url && typeof data?.innerHTML === "string") {
    const parsed = extractFromInnerHTML(data.innerHTML);
    url = parsed.url ?? url;
    alt = parsed.alt ?? alt ?? "";
    caption = parsed.caption ?? caption;
  }

  const widthStyle = {
    1: "md:w-full ",
    2: "md:w-[calc(50%-1.5rem*0.5)] ",
    3: "md:w-[calc(33.333%-1.5rem*0.66667)] ",
    4: "md:w-[calc(25%-1.5rem*0.75)] ",
    5: "md:w-[calc(20%-1.5rem*0.8)] ",
    6: "md:w-[calc(16.666%-1.5rem*0.83333)] ",
    7: "md:w-[calc(14.28571%-1.5rem*0.85714)] ",
    8: "md:w-[calc(12%-1.5rem*0.875)] ",
  };

  return (
    <figure
      className={`${openImage ? "cursor-pointer" : ""} ${
        columns ? `${widthStyle[columns]} w-[calc(50%-1.5rem*0.5)]` : ""
      } ${
        parentisGallery
          ? "flex flex-col items-stretch justify-start max-w-full relative grow-0 shrink-0"
          : "mb-6 last:mb-0"
      }`}
      onClick={() => openImage && openImage()}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-md">
        {url && (
          <Image
            src={url}
            alt={alt || ""}
            fill
            className="object-cover"
          />
        )}
      </div>

      {caption && (
        <figcaption className="w-full mt-4 text-center text-dark-text">
          {printHTML(caption)}
        </figcaption>
      )}
    </figure>
  );
};

export default CoreImage;
